import { BottomSheet, type UseModalState } from "@src/appV2/redesign/system/ui-components";

import { TooFarAwayContent } from "../../Timekeeping/TimekeepingActions/TooFarAwayContent";

interface TooFarAwayBottomSheetProps {
  modalState: UseModalState;
  workplaceName: string;
  onTryAgain: () => Promise<void>;
  onSkipLocationCheck: () => void;
  onCancel: () => void;
}

export function TooFarAwayBottomSheet({
  modalState,
  workplaceName,
  onTryAgain,
  onSkipLocationCheck,
  onCancel,
}: TooFarAwayBottomSheetProps) {
  return (
    <BottomSheet modalState={modalState} canDismiss={false}>
      <TooFarAwayContent
        workplaceName={workplaceName}
        onTryAgain={onTryAgain}
        onSkipLocationCheck={onSkipLocationCheck}
        onCancel={onCancel}
      />
    </BottomSheet>
  );
}
